// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","active":"Button_active__iTrrO"};